module.exports = __webpack_public_path__ + "img/node-charging-transparent.5452d851.webp";